import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, useParams } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import MainView from './components/MainView';

require('dotenv').config(); // load .env

export const DEBUG = false;

// List of valid widget IDs
const validWidgetIds = [
    '5420133a-0472-433c-88f7-7693da562e0c', 
    '2f89ba4b-6e4f-4663-80a3-e92031353a39', 
    '44747eb7-635d-41af-be87-f553429ebbbe',
    'b8b2383c-488f-4958-be0c-c62630c10566',
    '375b0cb8-ee06-480f-b5bc-ff9c2b7e5cff',
    '8e0e0983-45bf-46cb-a030-afac03ae8208',
    'b40f4804-d2cf-424e-a8d0-4a8e5cc7733c',
    '5670f71a-85cd-43f9-9163-4317149ffe73',
    '226ee6be-c097-4378-b35e-4a1ee8531519',
    'e208ef4c-883d-46c1-a6d1-578505d83fad',
    'af393779-99f4-487a-adca-1340371bf8ca',
    '08f76240-458d-4b6e-abaa-46701fc06fbc',
    '3501ba25-3699-429c-bd8b-b015ef1465c1',
    '99c4723c-5444-49a0-8ca5-f26511aca939',
    '87c5b0f0-e906-4ed8-8488-7b9bb93b03cb',
    '5c7ace17-180f-48a5-adda-d4060305e1bf',
    '9bb460d9-f992-40b8-a933-64b01e170dfa'
]; 

// Error page component
const ErrorPage = () => (
    <Modal show={true} backdrop={false}>
        <div className="center-flex">
            <h2>Something went wrong</h2>
        </div>
    </Modal>
);

// Component to validate widget ID
const ValidatedMainView = () => {
  const { widgetId } = useParams();

  if (!validWidgetIds.includes(widgetId)) {
      return <ErrorPage />; 
  }

  return <MainView />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Router>
        <Routes>
            <Route path="/:widgetId" element={<ValidatedMainView />} />
            <Route path="/" element={<ErrorPage />} />
        </Routes>
    </Router>
);
